import { Record } from 'immutable';
import { createSyncAction } from '@bimser/core';
import * as ActionTypes from '../actionTypes';

export function beginRequest(panelId: string) {
	const payload = Record<any>({ panelId: '' })({ panelId });
	return createSyncAction(ActionTypes.BEGIN_REQUEST, payload);
}

export function endRequest(panelId: string) {
	const payload = Record<any>({ panelId: '' })({ panelId });
	return createSyncAction(ActionTypes.END_REQUEST, payload);
}
